import { render, staticRenderFns } from "./vDropdownButton.vue?vue&type=template&id=1426ba3a&scoped=true"
import script from "./vDropdownButton.vue?vue&type=script&lang=ts"
export * from "./vDropdownButton.vue?vue&type=script&lang=ts"
import style0 from "./vDropdownButton.vue?vue&type=style&index=0&id=1426ba3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1426ba3a",
  null
  
)

export default component.exports